(() => {
  let isInitialized = false;
  let isTriggering = false;
  
  function triggerUpdates() {
    if (isTriggering) return;
    isTriggering = true;
    
    [800, 1500, 2500].forEach(delay => {
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('ocu:cart:update'));
      }, delay);
    });
    
    setTimeout(() => {
      isTriggering = false;
    }, 3000);
  }

  function initializeListeners() {
    if (isInitialized) return;
    isInitialized = true;

    document.addEventListener('click', (e) => {
      const target = e.target.closest('.ocu-quantity-minus, .ocu-quantity-plus, .ocu-cart-line-item-remove');
      if (target) {
        triggerUpdates();
      }
    }, true);

    const shadowObserver = new MutationObserver(() => {
      document.querySelectorAll('*').forEach(el => {
        if (el.shadowRoot) {
          el.shadowRoot.addEventListener('click', (e) => {
            const target = e.target.closest('.ocu-quantity-minus, .ocu-quantity-plus, .ocu-cart-line-item-remove');
            if (target) {
              triggerUpdates();
            }
          }, true);
        }
      });
    });

    shadowObserver.observe(document.body, { childList: true, subtree: true });

    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      if ((url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) && !url.includes('?ocu')) {
        return originalFetch.apply(this, args).then(response => {
          triggerUpdates();
          return response;
        });
      }
      return originalFetch.apply(this, args);
    };
  }

  const drawerObserver = new MutationObserver(() => {
    const drawer = document.querySelector('.ocu-cart-drawer.ocu-visible');
    if (drawer && !isInitialized) {
      setTimeout(() => {
        initializeListeners();
      }, 500);
    }
  });

  drawerObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();